import client from './axiosConfig';

export const customerRegistration = (data) => {
    const config = {
        url: `customer/register/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const vendorRegistration = (data) => {
    const config = {
        url: `vendor/register/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const vendorKYC = (data) => {
    const config = {
        url: `vendor/kyc-upload/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const LoginApi = (data) => {
    const config = {
        url: `otp-login/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const sendOtpForLogin = (data) => {
    const config = {
        url: `send-otp/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const LogoutAPI = () =>{
    const config = {
        url : `logout/`,
        method: 'POST'
    }
    return client(config)
}